module.exports = __webpack_public_path__ + "img/decoration-left.44237aa5.svg";